import axios from "axios";
 export const Updateprofile = async(data,setter) => {
    const {admin_name,admin_email,admin_password,admin_image} = data;
    const {getName,getImage,FetchData,setError} = setter;
        try {
        const formData = new FormData();
        formData.append('admin_name',admin_name);
        formData.append('admin_email',admin_email);
        formData.append('admin_password',admin_password);
        formData.append('admin_image',admin_image);
        const response = await axios.post('https://land-survey-project-2.onrender.com/UpdateAdmin',formData);
        if(response.data.status){
        getImage(response.data.admin.admin_image);
        getName(response.data.admin.admin_name);
        setError('');
        alert('You Have Updated Your Profile!');
        }else{
        if(response.data.error){
             const {admin_name: errName,admin_email: errEmail,admin_password: errPassword} = response.data.error;
        setError(errName ?. msg || errEmail ?. msg || errPassword ?. msg);
        }else{
            setError(response.data.message || 'Spmething went wrong');
        }
        }
        if(FetchData)   await FetchData();
        } catch (err) {
         alert("Oops! We couldn't connect to the server. Please try again later.");
            console.log(err.message);
        }
        }